import clsx from 'clsx'
import ContentViewerConstructor from '@/content-viewer/components/ContentViewerConstructor'

/** Keep the source mounted while switching tabs so its position and loaded content survive. */
export default function TableSourcePanel({ visible, conversationId = '' }: { visible: boolean; conversationId?: string }) {
  return (
    <div
      role="tabpanel"
      id="table-source-content"
      aria-labelledby="table-source-tab"
      onKeyDown={(event) => {
        if (event.key === 'Escape' && !event.defaultPrevented) document.getElementById('table-source-tab')?.focus()
      }}
      className={clsx('absolute inset-0 flex flex-col overflow-hidden', !visible && 'invisible')}
    >
      <ContentViewerConstructor conversationId={conversationId} headerVariant="compact-source-tab" />
    </div>
  )
}
